import { useMemo } from 'react';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

import { useSessionData } from '@confluence/session-data';
import { markErrorAsHandled } from '@confluence/graphql';
import { fg } from '@confluence/feature-gating';

export const useIsHighlightOptionPanelEnabled = () => {
	const { userId } = useSessionData();
	const { data, loading, error } = useQuery(
		gql`
			query useIsHighlightOptionPanelEnabledQuery {
				userPreferences {
					highlightOptionPanelEnabled
				}
			}
		`,
		{
			fetchPolicy: 'cache-and-network',
			skip: !fg('confluence_frontend_check_user_highlight_options') || !userId,
		},
	);

	return useMemo(() => {
		if (!fg('confluence_frontend_check_user_highlight_options')) {
			return { isHighlightOptionPanelEnabled: true };
		}

		// We always want to default to true until we get a result
		let isHighlightOptionPanelEnabled = true;

		if (error) {
			// We always want to handle errors caused from this, just default to existing behavior
			markErrorAsHandled(error);
		}

		if (!loading && data) {
			isHighlightOptionPanelEnabled = data?.userPreferences.highlightOptionPanelEnabled;
		}

		return { isHighlightOptionPanelEnabled };
	}, [data, loading, error]);
};
